// utils/token.ts
export function decodeTokenToData<T = any>(token: string): T {
  // Soporta base64url (JWT-style): - y _ en lugar de + y /
  let base64 = token.replace(/-/g, "+").replace(/_/g, "/");

  // Padding para que length sea múltiplo de 4
  const pad = base64.length % 4;
  if (pad) base64 += "=".repeat(4 - pad);

  // Decode
  const jsonStr = atob(base64);

  // Parse
  return JSON.parse(jsonStr) as T;
}
